import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Component, Input, TemplateRef, ViewChild } from "@angular/core";

@Component({
  selector: "ta-page-body",
  template: `
    <ng-template #template> <ng-content></ng-content> </ng-template>
  `
})
export class PageBodyComponent {
  @ViewChild("template", { static: true }) template: TemplateRef<void>;

  @Input()
  get transparent(): boolean {
    return this._transparent;
  }
  set transparent(val: boolean) {
    this._transparent = coerceBooleanProperty(val);
  }
  private _transparent = false;
}
